export default {
    add_all_materials_from_warehouse: "Bütün materialları anbardan əlavə et",
    add_good: "Məhsulu əlavə etmək",
    add_material: "Material əlavə et",
    add_new: "Yeni əlavə et",
    adding_new_supplier: "Yeni təchizatçının əlavə olunması",
    addition: "Gəlir",
    address: "Ünvan",
    adjustment: "Düzəliş",
    amount: "Miqdar",
    amount_of_stock_on_all_warehouses: "Klinikanın bütün anbarlarında mövcud olan ümumi mal miqdarı",
    approve: "Təsdiq et",
    approved: "Təsdiq olundu",
    are_you_sure_you_want_to_delete_group: "Qrupu silmək istədiyinizə əminsiniz?",
    are_you_sure_you_want_to_delete_kit: "Komplekti silmək istədiyinizə əminsiniz?",
    are_you_sure_you_want_to_delete_supplier: "Təchizatçını silmək istədiyinizə əminsiniz?",
    are_you_sure_you_want_to_delete_warehouse: "Anbarı silmək istədiyinizə əminsiniz?",
    artikul: "Artikul",
    available_for_sale: "Satış üçün mövcuddur",
    bank_requisites: "Bank rekvizitləri",
    barcode: "Barkod",
    beginning_balance: "Başlanğıc qalığı",
    bin: "Biznes ID nömrəsi (BİN)",
    branch: "Filial",
    bulk_addition: "Qrup ilə əlavə et",
    by_categories: "Kateqoriyalar üzrə",
    consumption: "İstifadə",
    consumption_manual: "Əl ilə istifadə",
    contact_person: "Əlaqəli şəxs",
    contragent: "Tərəfdaş",
    cost: "Dəyər",
    created: "Yaradıldı",
    current_stock: "Cari qalıq",
    default_for_sale: "Məhsul satış üçün standart olaraq istifadə edin",
    default_for_writeoff: "Materialın silinməsi üçün standart olaraq istifadə edin",
    destination: "Təyinat",
    details: "Detallar",
    difference: "Fərq",
    documents: "Sənədlər",
    draft: "Qaralama",
    enter_title_or_barcode: "Başlığı və ya barkodu daxil edin",
    factual_amount: "Faktiki miqdar",
    finished: "Təsdiqləndi",
    finished2: "Tamamlandı",
    found_similar_material: "Oxşar material tapıldı",
    from: "kimdən",
    from_warehouse: "Anbardan köçürmə",
    from_where: "Haradan",
    general_price: "Ümumi məbləğ",
    general_stock: "Ümumi qalıq",
    group: "Qrup",
    groups: "Qruplar",
    id: "ID",
    in_warehouse: "Anbarda",
    inventarization: "İnventarizasiya",
    kit: "Komplekt",
    Kit: "Komplekt",
    kits: "Komplektlər",
    material: "Material",
    materialgroup: "Qrup",
    materials: "Materiallar",
    materialstock: "Material",
    movement: "Köçürmə",
    movement_from: "Köçürmə",
    movement_to: "Köçürmə",
    movements: "Hərəkətlər",
    nomenclature: "Nomenklatura",
    not_enough_material: "Kifayət qədər material yoxdur",
    notify_when_stock: "Qalıq azaldıqda xəbərdar et",
    on_visit_close: "Səfəri bağlayanda",
    on_visit_save: "Ziyarətə qənaət edərkən",
    operation: "Əməliyyat",
    parent_category: "Əsas kateqoriya",
    parent_group: "Əsas qrup",
    physical: "Fiziki",
    price_will_be_used_automatically_from_addition: "Qiymət qəbz sənədindən avtomatik tətbiq olunacaq",
    print: "Çap et",
    prohibit_minus_stocks: "Materialların mənfi qalıqlarına yazılmasını qadağan et",
    prohibit_minus_stocks_in_warehouse_documents: "Bu parametr 'Anbar' bölməsində sənədləri doldurarkən materialların mənfi olaraq silinməsini qadağan edir",
    prohibit_minus_stocks_on_visit_closing: "Ziyarət materiallarının mənfi olaraq silinməsini qadağan edin (ziyarətin başa çatdırılmasına qadağa)",
    purchase_price: "Satınalma qiyməti",
    return: "Geri qaytarma",
    returns: "Geri qaytarmalar",
    sale_of_goods_refund: "Satış mallarının geri qaytarılması",
    sale_price: "Satış qiyməti",
    stocks: "Qalıqlar",
    stocks_archive: "Materiallar arxivi",
    supplier: "Təchizatçı",
    suppliers: "Təchizatçılar",
    to_warehouse: "Anbara köçürmə",
    to_where: "Hara",
    trying_to_writeoff: "Silməyə cəhd edin",
    type: "Növ",
    unit_of_measure: "Ölçü vahidi",
    virtual: "Virtual",
    warehouse_amount: "Anbarda miqdar",
    warehouseoperation: "Əməliyyatlar",
    warehouses: "Anbarlar",
    write_off: "Silinmə",
    write_off_materials: "Materialları yazın"
}
